import React from 'react';
import { number, arrayOf, string, shape, boolean } from 'prop-types';

import Highcharts from 'highcharts';
import addNoDataModule from 'highcharts/modules/no-data-to-display';
import HighchartsReact from 'highcharts-react-official';

addNoDataModule(Highcharts);

const axisOptions = shape({
  lineColor: string,
  tickLength: number,
  categories: arrayOf(string),
  title: shape({
    enabled: boolean,
    text: string
  }),
  labels: shape({
    style: shape({
      color: string,
      fontSize: string
    })
  }),
  noDataText: string
});

class LineChart extends React.Component {
  static propTypes = {
    xAxisOptions: axisOptions,
    yAxisOptions: axisOptions,
    plotOptions: shape({
      column: shape({
        pointWidth: number,
        pointPadding: number,
        groupPadding: number
      })
    }),
    seriesData: arrayOf(
      shape({
        animation: boolean,
        cursor: string,
        name: string,
        borderColor: string,
        label: shape({
          enabled: boolean
        }),
        showInLegend: boolean,
        data: arrayOf(
          shape({
            name: string,
            y: number
          })
        )
      })
    ),
    width: number,
    height: number
  };

  render() {
    const { xAxisOptions, yAxisOptions, plotOptions, seriesData, width, height, noDataText } = this.props;

    const config = {
      chart: {
        type: 'line',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        title: {
          text: null,
          enabled: false
        },
        legend: {
          enabled: false
        },
        width,
        height,
        style: { fontFamily: '"Roboto", sans-serif', fontSize: '12px' }
      }
    };

    config.xAxis = xAxisOptions;
    config.yAxis = yAxisOptions;
    config.plotOptions = plotOptions;
    config.series = seriesData;

    config.credits = {
      enabled: false
    };

    config.title = {
      text: null
    };

    config.lang = {
      noData: noDataText
    };

    config.noData = {
      style: {
        fontWeight: 'bold',
        fontSize: '16px',
        color: '#c0c0bf'
      }
    };

    return <HighchartsReact highcharts={Highcharts} options={config} allowChartUpdate={true} />;
  }
}

export default LineChart;
